import axios from 'axios';
import { prepareWriteContract, readContract } from '@wagmi/core';

const api = axios.create({
  baseURL: 'https://ethereum-api.xyz',
  timeout: 30000, // 30 secs
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

export async function apiGetAccountAssets(address, chainId) {
  const response = await api.get(`/account-assets?address=${address}&chainId=${chainId}`);
  const { result } = response.data;
  return result;
}

export async function apiGetAccountTransactions(address, chainId) {
  const response = await api.get(`/account-transactions?address=${address}&chainId=${chainId}`);
  const { result } = response.data;
  return result;
}

export const apiGetAccountNonce = async (address, chainId) => {
  const response = await api.get(`/account-nonce?address=${address}&chainId=${chainId}`);
  const { result } = response.data;
  return result;
};

export const apiGetGasPrices = async () => {
  const response = await api.get(`/gas-prices`);
  const { result } = response.data;
  return result;
};

export async function getAbiFromTokenAddress(/* tokenAddress, network */) {
  const abiVersion = process.env.REACT_APP_TREX_ABI;
  let ABI;

  if (['3.2', '3.2.0'].includes(abiVersion)) {
    ABI = require('abi/abi-trex.v3.2.0.json');
  } else {
    ABI = require('abi/abi-trex.v3.4.0.json');
  }

  return JSON.stringify(ABI);
}

export const getBalanceERC20 = async ({ tokenAddress, walletAddress }) => {
  let minABI = [
    // balanceOf
    {
      constant: true,
      inputs: [{ name: '_owner', type: 'address' }],
      name: 'balanceOf',
      outputs: [{ name: 'balance', type: 'uint256' }],
      type: 'function',
    },
    // decimals
    {
      constant: true,
      inputs: [],
      name: 'decimals',
      outputs: [{ name: '', type: 'uint8' }],
      type: 'function',
    },
  ];
  const contractConfig = {
    address: tokenAddress,
    abi: minABI,
    functionName: 'balanceOf',
  };
  const { request } = await prepareWriteContract({
    ...contractConfig,
    args: [walletAddress],
  });
  const balance = await readContract(request);
  return balance;
};
